import { defineMessages } from 'react-intl';

export default defineMessages({
  addQuantityText: {
    id: 'ordering.stepper.addQuantityText',
    defaultMessage: 'Add {productOptionName}',
    description: 'Text for adding product option',
  },
  decreaseQuantityMessage: {
    id: 'ordering.stepper.decreaseQuantityMessage',
    defaultMessage: 'Quantity minus',
    description: 'Aria label for stepper decrease button.',
  },
  increaseQuantityMessage: {
    id: 'ordering.stepper.increaseQuantityMessage',
    defaultMessage: 'Quantity add',
    description: 'Aria label for stepper increase button.',
  },
});
